import {Component} from '@angular/core';

@Component({
    selector: 'app-walkthrough-complete',
    templateUrl: './walkthrough-complete.component.html',
    styleUrls: ['../product-walkthrough.component.scss'],
    standalone: false
})
export class WalkthroughCompleteComponent
{
}
